module.exports = __webpack_public_path__ + "static/img/3.22fd3b1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/3.jpeg
// module id = xJ8G
// module chunks = 45